import { PopoverContacts } from '@sequencehq/quote-content'
import { usePopoverCounterSigners } from './usePopoverCounterSigners'

export const PopoverCounterSigners = () => {
  const hook = usePopoverCounterSigners()

  if (!hook.isVisible) {
    return null
  }

  return <PopoverContacts width="300px" contacts={hook.contacts} />
}
